import { StartScreenPrompt } from '@openai/chatkit-react'
import { TChatKitConstants, TTranslationFunction } from '../_lib/types'

/**
 * Get localized ChatKit constants for Logo Design Agent
 * @param t - Translation function from useTranslations('design')
 * @returns Localized ChatKit constants
 */
export function getChatKitConstants(
  t: TTranslationFunction,
): TChatKitConstants {
  return {
    greeting: t('chatkit_greeting'),
    starterPrompts: [
      {
        label: t('starter-prompts.design-a-logo-from-text-or-image.label'),
        prompt: t('starter-prompts.design-a-logo-from-text-or-image.prompt'),
        icon: 'sparkle',
      },
      {
        label: t('starter-prompts.visual-asset-design.label'),
        prompt: t('starter-prompts.visual-asset-design.prompt'),
        icon: 'book-open',
      },
      {
        label: t('starter-prompts.apply-the-design-to-my-project.label'),
        prompt: t('starter-prompts.apply-the-design-to-my-project.prompt'),
        icon: 'lightbulb',
      },
    ],
    placeholder: t('chatkit_placeholder'),
  }
}
